module.exports = __webpack_public_path__ + "static/media/tween.3a139f27.svg";